"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:7.1.0'] && _();
}
catch (e) { }
